import { Menubar as RadixMenuBar } from "radix-ui";
import { Menu, type MenuItems } from "../menu/menu";
import { cn } from "../utils";

/** Props Interface */
interface MenuBarProps {
	items: Array<MenuBarItem>;
}

export interface MenuBarItem {
	label: string;
	items: () => MenuItems;
}

export function MenuBar({ items }: MenuBarProps) {
	return (
		<RadixMenuBar.Root className={cn("h-stack card w-max gap-0", "p-0.5")}>
			{items.map((item) => (
				<Menu
					type="menu-bar"
					items={item.items}
					key={item.label}
				>
					<button
						type="button"
						className={cn(
							"px-2 py-1 rounded-[0.6rem]",
							"data-[state=open]:bg-primary-100",
							"data-[state=open]:dark:bg-accent-600",
							"data-[state=open]:dark:!text-white",
							"focus:ring-2 ring-accent-500",
							"text-sm",
						)}
					>
						<span>{item.label}</span>
					</button>
				</Menu>
			))}
		</RadixMenuBar.Root>
	);
}
